import { Card, Skeleton, cn } from "@rarible_int/anaconda_ui_components"

interface WidgetLayoutProps {
  header: React.ReactNode
  price: React.ReactNode
  priceInfo: React.ReactNode
  primaryAction: React.ReactNode
  secondaryAction: React.ReactNode
  isFolded?: boolean
}

export function OrderWidgetLayout({
  header,
  price,
  priceInfo,
  primaryAction,
  secondaryAction,
  isFolded,
}: WidgetLayoutProps) {
  return (
    <Card
      className={cn("flex flex-col gap-4 p-4", !isFolded && "border-brand")}
    >
      <div className="flex flex-col gap-1">
        {header}
        {!isFolded && price}
        {!isFolded && priceInfo}
      </div>
      {!isFolded && (
        <div className="flex items-center gap-[10px]">
          {primaryAction}
          {secondaryAction}
        </div>
      )}
    </Card>
  )
}

export function OrderWidgetActionSkeleton({
  className,
}: { className?: string }) {
  return <Skeleton className={cn("h-[34px] w-20", className)} />
}

export function OrderWidgetSkeleton() {
  return (
    <OrderWidgetLayout
      header={<Skeleton className="h-6 w-full" />}
      price={<Skeleton className="h-9 w-[100px]" />}
      priceInfo={
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <Skeleton className="h-6 w-[150px]" />
        </div>
      }
      primaryAction={<OrderWidgetActionSkeleton />}
      secondaryAction={<OrderWidgetActionSkeleton className="w-full" />}
    />
  )
}
